import React, { FC, MouseEvent } from 'react'
import cx from 'classnames'
import { Icon } from '@ui'
import { PopoverInteractionKind, Position } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import css from './markDeafaultLocationButton.module.scss'

type PropsT = {
  className?: string
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  isDefault: boolean
}

const MarkDefaultLocationButton: FC<React.PropsWithChildren<PropsT>> = ({
  className,
  onClick,
  isDefault,
}) => {
  return (
    <Tooltip2
      className={cx(css.mark_default, className)}
      content={`${isDefault ? 'Default' : 'Mark as default'} location`}
      position={Position.TOP}
      interactionKind={PopoverInteractionKind.HOVER_TARGET_ONLY}
    >
      <button data-test="mark-default-test" onClick={onClick}>
        <Icon name="map-pin" className={isDefault ? 'fas' : ''} />
      </button>
    </Tooltip2>
  )
}

export default MarkDefaultLocationButton
